import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { NOT_WORK, ROUND_THE_CLOCK } from '@/constants';

import 'dayjs/locale/ru';
import 'dayjs/locale/uk';

dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

export const getNormalizeSheduleList = (schedule) =>
  Object.keys(schedule).map((day) => {
    const { closeTime, fullTime, openTime, closed } = schedule[day];
    const fullTimeStatus = fullTime ? ROUND_THE_CLOCK : '';
    const closedStatus = closed ? NOT_WORK : '';
    const options = closedStatus || fullTimeStatus;

    return {
      day,
      begin: openTime,
      end: closeTime,
      options,
    };
  });

export const STATUSES = {
  active: 'active',
  inactive: 'inactive',
};

export const normalizeOrganizationsBySlugData = ({ data }) => {
  if (!data?.id) {
    return null;
  }

  const {
    id,
    financeId,
    fullLogo,
    menu,
    name,
    nameG,
    nameP,
    slug,
    license,
    vendorLink,
    ratingStability,
    popular,
    cardsPriority,
    backgroundImage,
    promoImage,
    site,
  } = data;

  const bannerImg = promoImage || backgroundImage;

  return {
    id: parseInt(financeId, 10) || 0,
    minfinId: parseInt(id, 10) || 0,
    logoUrl: `https://minfin.com.ua${fullLogo}`,
    slug: slug.toLowerCase(),
    banner: bannerImg ? encodeURI(bannerImg) : null,
    menu,
    companyName: name,
    companyNameG: nameG,
    companyNameP: nameP,
    companySite: site,
    companyRating: ratingStability,
    license,
    popular,
    vendorLink,
    cardsPriority,
  };
};
